import { Link } from 'react-router-dom';
import { ArrowDown, ArrowRight, CheckCircle, Lock } from '@phosphor-icons/react';
import { Button } from '@/components/ui';

export function Hero() {
  return (
    <header className="relative mesh-bg overflow-hidden pb-32 pt-24 lg:pb-40 lg:pt-36">
      <div className="mx-auto grid max-w-container items-center gap-16 px-6 lg:grid-cols-[1fr_1.1fr]">
        <div className="max-w-xl animate-fade-in-up opacity-0">
          <span className="mb-8 inline-flex items-center gap-2 rounded-full border border-line bg-board px-3 py-1 text-xs font-medium text-ink-muted shadow-card">
            <span className="inline-block h-2 w-2 animate-pulse rounded-full bg-emerald-500" />
            yes this is a real website
            <ArrowRight size={12} className="ml-1" />
          </span>
          <h1 className="mb-6 font-display text-5xl font-semibold leading-[1.05] tracking-[-0.03em] text-ink lg:text-[4.2rem]">
            Stop saying you'll make a portfolio
            <br />
            <span className="text-ink-muted">and just make one.</span>
          </h1>
          <p className="mb-10 max-w-md text-lg leading-relaxed text-ink-muted">
            Pick a template, fill in your work, publish. That's genuinely it. We didn't add anything else because we didn't want to.
          </p>
          <div className="flex flex-col items-start gap-4 sm:flex-row sm:items-center">
            <Link to="/sign-in" className="w-full sm:w-auto">
              <Button variant="primary" size="lg" fullWidth>
                Start building for free
              </Button>
            </Link>
            <a href="#templates" className="w-full sm:w-auto">
              <Button
                variant="secondary"
                size="lg"
                fullWidth
                trailingIcon={<ArrowDown size={16} />}
              >
                Explore templates
              </Button>
            </a>
          </div>
          <p className="mt-4 flex items-center gap-2 text-xs text-ink-faint">
            <CheckCircle size={14} weight="fill" className="text-ink-muted" />
            Free. We'll figure out the business model later.
          </p>
        </div>

        <div className="relative hidden h-[500px] w-full animate-fade-in-up opacity-0 [animation-delay:200ms] md:block">
          <HeroPreview />
          <HeroDeployPanel />
        </div>
      </div>
    </header>
  );
}

function HeroPreview() {
  return (
    <div className="absolute right-0 top-0 z-20 flex h-[420px] w-[580px] flex-col overflow-hidden rounded-xl border border-line bg-board shadow-float">
      <div className="flex h-10 items-center gap-2 border-b border-line bg-canvas px-4">
        <div className="flex gap-1.5" aria-hidden>
          <span className="h-2.5 w-2.5 rounded-full bg-line" />
          <span className="h-2.5 w-2.5 rounded-full bg-line" />
          <span className="h-2.5 w-2.5 rounded-full bg-line" />
        </div>
        <div className="mx-auto flex items-center gap-2 rounded-md border border-line bg-board px-32 py-1 font-mono text-[10px] font-medium text-ink-faint">
          <Lock size={10} weight="fill" className="text-ink-muted" />
          alyssa.portfilo.online
        </div>
      </div>
      <div className="flex-1 overflow-hidden bg-[#F8F9FA] p-8">
        <div className="mb-6 h-20 w-20 overflow-hidden rounded-full border border-line">
          <img
            src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80"
            alt="Alyssa portrait"
            className="h-full w-full object-cover"
          />
        </div>
        <h3 className="mb-3 font-editorial text-3xl italic">Alyssa Chen</h3>
        <p className="mb-8 font-mono text-xs text-ink-muted">PRODUCT DESIGNER · NEW YORK</p>
        <div className="grid grid-cols-2 gap-4">
          {[
            'https://images.unsplash.com/photo-1618761714954-0b8cd0026356?w=600&q=80',
            'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=600&q=80',
          ].map((src) => (
            <div
              key={src}
              className="relative h-32 overflow-hidden rounded-lg border border-line bg-board shadow-card"
            >
              <img src={src} alt="" className="h-full w-full object-cover opacity-80" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function HeroDeployPanel() {
  return (
    <div className="absolute -bottom-6 -left-12 z-30 w-[320px] animate-float-slow rounded-xl border border-ink-muted bg-ink p-5 font-mono text-xs text-board shadow-float">
      <div className="mb-4 flex items-center justify-between border-b border-white/15 pb-2">
        <span className="text-ink-faint">deploy.yml</span>
        <span className="flex items-center gap-2 text-emerald-400">
          <CheckCircle weight="fill" size={14} /> Complete
        </span>
      </div>
      <div className="space-y-2 text-ink-faint">
        <p>
          <span className="text-sky-300">→</span> building your portfolio…
        </p>
        <p>
          <span className="text-sky-300">→</span> looking good actually
        </p>
        <p>
          <span className="text-sky-300">→</span> published.
        </p>
        <p className="mt-4 border-t border-white/15 pt-2 font-medium text-board">
          that took less time than writing your bio
        </p>
      </div>
    </div>
  );
}
